"use client";

import { Accordion, Stack, Text, Title } from "@mantine/core";

import type { FaqItem } from "../_content/types";
import { renderInline } from "./inline";

interface ArticleFaqProps {
  items: FaqItem[];
}

export function ArticleFaq({ items }: ArticleFaqProps) {
  return (
    <Stack gap="md">
      <Title order={2}>Frequently Asked Questions</Title>
      <Accordion variant="separated">
        {items.map((item, index) => (
          <Accordion.Item key={index} value={`faq-${index}`}>
            <Accordion.Control>{item.question}</Accordion.Control>
            <Accordion.Panel>
              <Text>{renderInline(item.answer)}</Text>
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </Stack>
  );
}
